import React from 'react';

function AddRightIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			fill='none'
			viewBox='0 0 16 16'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M14.333 4.333c-.132-.729-.366-1.266-.78-1.69-.953-.976-2.486-.976-5.553-.976-3.067 0-4.6 0-5.553.976-.414.424-.648.961-.78 1.69M1.667 11.667c.132.729.366 1.266.78 1.69.953.976 2.486.976 5.553.976 3.067 0 4.6 0 5.553-.976.414-.424.648-.961.78-1.69M14.33 6.667c.003.39.003.858.003 1.316 0 .457 0 .967-.003 1.358M1.67 6.667c-.003.39-.003.858-.003 1.316 0 .457 0 .967.003 1.358M14.333 8h-1M2.667 8h-1M8 6l2 2m0 0H6m4 0L8 9.667'
			></path>
		</svg>
	);
}

export default AddRightIcon;
